<template>
  <div class="box">
    <!-- 视频播放区域 -->
    <div v-if="detailData?.videoUrl" class="video-container">
      <video-player class="video-player vjs-custom-skin"
        ref="videoPlayer" :playsinline="true" :options="playerOptions" @pause="onPlayerPause($event)"
        @play="onPlayerPlay($event)" @ended="onPlayerEnded($event)" @ready="playerReadied">
      </video-player>
      <div class="video-click-overlay" @click.stop.prevent="onPlayerClick"></div>
    </div>
    
    <div class="detail-scroll-container">
      <div class="flex" style="flex: 0 0 auto;">
        <img :src="detailData.pic" alt="" class="img" />
        <div style="flex: 1;">
          <span style="font-size: 1.2rem; font-weight: 600;"> {{ detailData.name }}</span>
          <div style="margin-top: 0.6rem;">
            <span style="color: #666; font-size: 0.85rem;">导演： {{ detailData.director }}</span>
          </div>
          <div style="margin-top: 0.4rem;">
            <span style="color: #666; font-size: 0.85rem;">{{ detailData.filmTypes }}|{{ detailData.versionTypes }}</span>
          </div>
          <div class="flex" style="margin-top: 0.4rem;font-size: 0.85rem; color: #999;">
            <span> 上映日期: {{ this.$moment(detailData.publishDate).format('YYYY.MM.DD') }}</span>
            <span style="margin-left: 1.1rem;"> {{ detailData.duration }}分钟</span>
          </div>
        </div>
      </div>

      <p style="margin-top: 1.8rem;font-size: 1.1rem;margin-left: 1.5rem;flex: 0 0 auto; font-weight: 600;">主演 </p>
      <div class="texttitle">
        <span style=" font-size: 0.9rem; color: #666; line-height: 1.6;"> {{ detailData.cast }}</span>
      </div>
      
      <div class="intro-section">
        <div class="section-title">剧情介绍</div>
        <div class="section-content">{{ detailData.intro }}</div>
      </div>
    </div>

    <!-- 底部按钮区域 -->
    <div class="addCard">
      <div v-if="showButton == 2" class="buy" @click="goBack">返回</div>
      <div v-else class="buy" @click="goCinema">{{ buttonText }}</div>
    </div>
  </div>
</template>

<script>
import { videoPlayer } from "vue-video-player";
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'

export default {
  name: 'MovieDetail',
  components: { videoPlayer },
  data() {
    return {
      showButton: 0,
      detailData: {},
      isPlay: false,
      player: null,
      playerTimer: null,
      playerOptions: {
        sources: [{ type: "video/mp4", src: '' }],
        autoplay: false,
        muted: false,
        loop: false,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        controlBar: {
          timeDivider: false,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: false,
        },
      },
    };
  },
  computed: {
    buttonText() {
      if (!this.detailData.publishDate) return '立即购票';
      const publishDate = this.$moment(this.detailData.publishDate);
      if (publishDate.isAfter(this.$moment(), 'day')) {
        return '预售购票';
      }
      return '立即购票';
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    
    goCinema() {
      this.$router.push({
        path: "/Cinema",
        query: {
          filmId: this.detailData.filmId,
          movieName: this.detailData.name,
        },
      });
    },
    
    onPlayerPause() {
      this.isPlay = false;
    },
    
    onPlayerPlay() {
      this.isPlay = true;
    },
    
    onPlayerEnded() {
      this.isPlay = false;
    },
    
    onPlayerClick() {
      if (this.player && this.player.el_) {
        if (this.isPlay) {
          this.player.pause();
        } else {
          this.player.play();
        }
      }
    },
    
    playerReadied() {
      this.player = this.$refs.videoPlayer.player;
      if (this.player) {
        this.player.play();
        this.playerTimer = setInterval(() => {
          if (this.player && this.player.el_) {
            this.player.pause();
            clearInterval(this.playerTimer);
            this.playerTimer = null;
          }
        }, 200);
      }
    },
  },
  
  mounted() {
    this.detailData = JSON.parse(this.$route.query.item);
    this.playerOptions.sources[0].src = this.detailData.videoUrl;
    this.playerOptions.poster = this.detailData.pic;
    this.showButton = this.$route.query.showbutton;
    document.title = this.detailData.name;
  },
  
  beforeDestroy() {
    if (this.playerTimer) {
      clearInterval(this.playerTimer);
      this.playerTimer = null;
    }
    if (this.player) {
      this.player = null;
    }
  }
};
</script>

<style lang='scss' scoped>
.box {
  background-color: #f5f5f5;
  height: 100vh;
  display: flex;
  flex-direction: column;
  color: #333;
  position: relative;

  .img {
    width: 6rem;
    height: 8rem;
    border-radius: 0.5rem;
    margin: 1rem 1.5rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.texttitle {
  margin: 0.5rem 1.5rem 0;
  flex: 0 0 auto;
}

.detail-scroll-container {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 7rem;
  background: #fff;
  border-radius: 1rem 1rem 0 0;
  margin-top: 0.5rem;
  padding-top: 0.5rem;
}

.intro-section {
  margin: 1.8rem 1.5rem 2rem;
  
  .section-title {
    font-size: 1.1rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.6rem;
  }
  
  .section-content {
    color: #666;
    font-size: 0.9rem;
    line-height: 1.7;
    text-align: justify;
  }
}

.video-container {
  width: 100%;
  background-color: #000;
  min-height: 12rem;
  flex: 0 0 auto;
  position: relative;
  overflow: hidden;
}

.video-player {
  width: 100%;
}

.video-click-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  background: transparent;
}

.addCard {
  position: absolute;
  width: 90%;
  margin-left: 5%;
  padding-top: 0.5rem;
  bottom: 0.8rem;
}

.buy {
  border-radius: 1.5rem;
  padding: 0.8rem 0;
  width: 100%;
  font-size: 0.9rem;
  font-weight: 500;
  background: linear-gradient(135deg, #ff6b4a 0%, #ff8a65 100%);
  color: #fff;
  text-align: center;
  box-shadow: 0 4px 15px rgba(255, 107, 74, 0.3);
  
  &:active {
    opacity: 0.9;
    transform: scale(0.98);
  }
}
</style>